import { AbstractControl } from '@angular/forms'
import { parsePhoneNumberFromString } from 'libphonenumber-js/max'
import { AbstractValidator } from './abstract.validator'
import { ValidationTypes } from './validation.types'

export class PhoneValidator implements AbstractValidator {
  static type = ValidationTypes.validateWith

  static validateWith({ defaultCountry }: { defaultCountry: any }) {
    return (control: AbstractControl) => {
      if (control.pristine || control.value === '+') return null
      const parsedNumber = parsePhoneNumberFromString(control.value)
      const defaultCode = parsedNumber ? '+' + parsedNumber.countryCallingCode + ' 0' : '+0'
      if (control.value.startsWith(defaultCode)) {
        return { phone: 'Phone can not start with a leading zero after country code' }
      }
      try {
        const validity = parsedNumber ? parsedNumber.isValid() : false
        return validity ? null : { phone: `Invalid phone number` }
      } catch {
        return { phone: `Is an invalid phone number` }
      }
    }
  }
}
